const labelDesignerCtaSelector = '[data-label-designer-cta]';

/**
 * Build a label-designer URL for the selected bottle variant.
 * @param {string} baseUrl
 * @param {string} variantTitle
 * @returns {string}
 */
export function buildLabelDesignerUrl(baseUrl, variantTitle) {
  if (!variantTitle || variantTitle === 'Default Title') return baseUrl;

  return `${baseUrl}?bottle=${encodeURIComponent(variantTitle)}`;
}

/**
 * Keep every label-designer CTA for a product aligned with its selected variant.
 * @param {CustomEvent} event
 * @param {Document | Element} root
 * @returns {void}
 */
export function syncLabelDesignerCtas(event, root = document) {
  const productId = event.detail?.data?.productId;
  const variantTitle = event.detail?.resource?.title;
  if (!productId || !variantTitle) return;

  root.querySelectorAll(labelDesignerCtaSelector).forEach((link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    if (link.dataset.productId !== String(productId)) return;

    const baseUrl = link.dataset.baseUrl;
    if (!baseUrl) return;

    link.href = buildLabelDesignerUrl(baseUrl, variantTitle);
  });
}

if (typeof document !== 'undefined') {
  document.addEventListener('variant:update', syncLabelDesignerCtas);
}
